import { render, staticRenderFns } from "./indexDirector_original.vue?vue&type=template&id=43ca14b4"
import script from "./indexDirector_original.vue?vue&type=script&lang=js"
export * from "./indexDirector_original.vue?vue&type=script&lang=js"
import style0 from "./indexDirector_original.vue?vue&type=style&index=0&id=43ca14b4&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43ca14b4')) {
      api.createRecord('43ca14b4', component.options)
    } else {
      api.reload('43ca14b4', component.options)
    }
    module.hot.accept("./indexDirector_original.vue?vue&type=template&id=43ca14b4", function () {
      api.rerender('43ca14b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/main/indexDirector_original.vue"
export default component.exports